var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.size || 24,"height":_vm.size || 24},on:{"click":function($event){return _vm.$emit('click')}}},[_c('use',{attrs:{"xlink:href":_vm.href}})])}
var staticRenderFns = []

export { render, staticRenderFns }